/* unplugin-vue-components disabled */import { render } from "./NoPermission.vue?vue&type=template&id=2deea7a4&scoped=true"
const script = {}

import "./NoPermission.vue?vue&type=style&index=0&id=2deea7a4&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2deea7a4"]])

export default __exports__